<template>
    <!-- 头像更换start -->
    <v-dialog
        v-model="visiableDialog"
        :mask-closable="false"
        class="change-avatar-dialog"
        title="编辑头像"
    >
        <div class="change-avatar-body">
            <div class="upload">
                <div class="upload-btn">
                    <v-button
                        :loading="uploading"
                        @click="handleChooseImg"
                        status="default"
                        icon="v-add"
                    >
                        重新选择
                    </v-button>
                    <input
                        ref="uploadImgInputRef"
                        v-show="false"
                        @change="handleFileChange"
                        accept=".bmp,.png,jpeg,.jpg"
                        type="file"
                    >
                </div>
                <div class="upload-tip">
                    <p class="upload-tip-text">
                        支持jpg、jpeg、png、bmp格式的图片
                    </p>
                    <p class="upload-tip-text">
                        文件小于2M
                    </p>
                </div>
            </div>
            <div class="change-avatar-box">
                <div class="avatar-select">
                    <v-image-cropper
                        v-model="cropperValue"
                        :ratio="1"
                        :width="320"
                        :height="320"
                        :src="imgSrc"
                        class="cropper2"
                        keep-ratio
                    />
                    <div
                        v-show="false"
                        class="img-wrapper"
                    >
                        <div class="select-box" />
                        <img
                            :src="defaultAvatar"
                            width="100%"
                            height="100%"
                            alt="头像预览"
                        >
                    </div>
                </div>
                <div class="avatar-preview">
                    <div class="preview">
                        <!-- <img :src="defaultAvatar" width="200" height="200" alt="头像预览"> -->
                        <div
                            :style="{
                                'background-image': `url(${imgSrc})`,
                                'background-size': backgroundSize,
                                'background-position': `${backgroundX} ${backgroundY}`
                            }"
                            class="preview-img"
                        />
                    </div>
                    <div class="avatar-history">
                        <p>我使用过的头像</p>
                        <div class="history-list">
                            <div
                                :key="i"
                                v-for="i of 3"
                                class="history-item"
                            >
                                <img
                                    v-if="historyImages[i - 1]"
                                    :src="historyImages[i - 1].url"
                                    @click="() => imgSrc = historyImages[i - 1].url"
                                    :class="historyImages[i - 1] ? 'click': ''"
                                    width="60"
                                    height="60"
                                >
                            </div>
                            <!-- <img
                                :src="historyImages[1] ? historyImages[1].url : defaultAvatar"
                                @click="() => imgSrc = historyImages[1] ? historyImages[1].url : imgSrc"
                                :class="historyImages[1] ? 'click': ''"
                                width="60"
                                height="60"
                                alt="使用过的头像"
                            >
                            <img
                                :src="historyImages[2] ? historyImages[2].url : defaultAvatar"
                                @click="() => imgSrc = historyImages[2] ? historyImages[2].url : imgSrc"
                                :class="historyImages[2] ? 'click': ''"
                                width="60"
                                height="60"
                                alt="使用过的头像"
                            > -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-row">
                <v-button
                    :loading="confirmAvatarLoading"
                    @click="handleConfirmAvatar"
                    status="primary"
                >
                    确定
                </v-button>
                <v-button
                    @click="visiableDialog = false"
                    style="margin-left: 12px;"
                >
                    取消
                </v-button>
            </div>
        </div>
    </v-dialog>
    <!-- 头像更换end -->
</template>
<script>
import catchErr from 'src/utils/catchError';
import Gateway from '@/utils/Gateway';
import Cookie from '@/utils/cookie';

const SET_AVATAR_URL = '/v1/basic/account_web/updateStaffFace';
const UPLOAD_IMG = '/mp/imgCommon/crop';
const HISTORY_IMG = '/v1/basic/account_web/staffHistoryFace';
export default {
    props: {
        defaultAvatar: {
            type: String,
            default: 'https://bqq.gtimg.com/qidian/src/themes/blue/common/images/default_avatar.png',
        },
    },
    data() {
        return {
            imgSrc: 'https://bqq.gtimg.com/qidian/src/themes/blue/common/images/default_avatar.png', // 1:1
            confirmAvatarLoading: false,
            historyImages: [],
            uploading: false,
            visiableDialog: false,
            cropperValue: {
                cropWidth: 60,
                cropHeight: 90,
                cropX: 100,
                cropY: 100,
                rotate: 0,
            },
        };
    },
    computed: {
        backgroundSize() {
            const { width, height, scale, cropWidth } = this.cropperValue;
            const value = `${((Math.min(width, height) * scale) / cropWidth) * 100}%`;
            console.log('position', width > height ? `auto ${value}` : `${value} auto`);
            return width > height ? `auto ${value}` : `${value} auto`;
        },
        backgroundX() {
            const { cropX, width, scale, cropWidth } = this.cropperValue;
            const diff = width * scale - cropWidth;
            const value = diff === 0 ? 0 : (cropX / diff) * 100;
            console.log('x:', `${value}%`);
            return `${value}%`;
        },
        backgroundY() {
            const { cropY, height, scale, cropHeight } = this.cropperValue;
            const diff = height * scale - cropHeight;
            const value = diff === 0 ? 0 : (cropY / diff) * 100;
            console.log('x:', `${value}%`);
            return `${value}%`;
        },
    },
    watch: {
        cropperValue: {
            handler(newValue) {
                console.log(JSON.stringify(newValue, null, 2));
            },
        },
    },
    methods: {
        handleChooseImg() {
            /* eslint-disable */
            const input = this.$refs.uploadImgInputRef;
            input && input.click();
        },
        fetchHistoryAvatar() {
            this.pageLoading = true;
            Gateway.post(HISTORY_IMG)
                .then(data => {
                    const { face } = data;
                    this.historyImages = face;
                })
                .catch(message => {
                    this.$message.error(message || '历史头像获取失败');
                })
                .then(() => {
                    this.pageLoading = true;
                })
        },
        handleConfirmAvatar() {
            this.confirmAvatarLoading = true;
            const scalc = (1 / this.cropperValue.scale);
            const data = {
                src: this.imgSrc,
                originWidth: scalc * this.cropperValue.cropWidth,
                originHeight: scalc * this.cropperValue.cropHeight,
                cropWidth: this.cropperValue.cropWidth,
                cropHeight: this.cropperValue.cropHeight,
                originX: scalc * this.cropperValue.cropX,
                originY: scalc * this.cropperValue.cropY,
                _bqq_csrf: Cookie.get('_bqq_csrf'),
            };
            const formData = new FormData();
            for(let key in data) {
                console.log(key, data[key]);
                formData.append(key, data[key]);
            }
            this.$ajax
                .write(`${UPLOAD_IMG}?type=crop`, formData, {
                    transformRequest(data) {
                        return data;
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res => {
                    if (res.r === 0) {
                        this.imgSrc = res.data.url;
                        return Gateway.post(SET_AVATAR_URL, {
                            url: res.data.url
                        });
                    } else {
                        return Promise.reject(res.msg);
                    }
                })
                .then(ret => {
                    this.fetchHistoryAvatar();
                    this.$emit('changeAvatar', this.imgSrc);
                    this.$message.success('头像更新成功');
                    this.visiableDialog = false;
                })
                .catch(err => {
                    this.$message.error(catchErr.catchErr(err));
                })
                .then(() => {
                    this.confirmAvatarLoading = false;
                })
        },
        handleFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;
            // 支持的图片格式
            const support = ['image/bmp', 'image/png', 'image/jpeg'];
            if (!support.find(v => v === file.type)) {
                return this.$message.error('不支持的图片格式');
            }
            console.log(file.size)
            if (file.size > 2048 * 1024) {
                return this.$message.error('图片大小超过2MB');
            }
            const formData = new FormData();
            formData.append('lbf-file-upload', file);
            formData.append('file_size_limit', '2MB');
            formData.append('file_types', '*.jpg;*.gif;*.jpeg;*.png;*.bmp')
            this.uploading = true;
            this.$ajax
             .write(`${UPLOAD_IMG}?type=upload`, formData, {
                    transformRequest(data) {
                        return data;
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res => {
                    this.uploading = false;
                    if (res.r === 0) {
                        this.imgSrc = res.data.url;
                    } else {
                        this.$message.error(catchErr.catchErr(res.msg));
                    }
                })
                .catch(err => {
                    this.uploading = false;
                    this.$message.error(catchErr.catchErr(err));
                })
        },
    }
};
</script>
<style lang="less">
.change-avatar-dialog {
    // z-index: 10001 !important;
    .v-dialog__content {
        padding: 16px 40px;
        width: 640px;
    }
    .v-dialog__title {
        font-size: 20px;
        line-height: 28px;
        height: 28px;
        color: #262d3d;
    }
    .change-avatar-body {
        .upload {
            display: flex;
            align-items: center;
            &-btn {
            }
            &-tip {
                margin-left: 10px;
                font-size: 12px;
                line-height: 17px;
                color: #000000;
                text-align: left;
            }
        }
        .change-avatar-box {
            display: flex;
            justify-content: space-between;
            margin-top: 16px;
            .avatar-select {
                .v-image-cropper__toolbar {
                    display: none;
                }
            }
            .avatar-preview {
                .preview {
                    width: 200px;
                    height: 200px;
                    position: relative;
                    &-img {
                        border-radius: 50%;
                        width: 200px;
                        height: 200px;
                    }
                    &:after {
                        content: '预览';
                        position: absolute;
                        left: 0;
                        top: 0;
                        color: #78849e;
                        font-size: 13px;
                        line-height: 18px;
                    }
                }
                .avatar-history {
                    margin-top: 36px;
                    p {
                        color: #78849e;
                        font-size: 13px;
                        line-height: 18px;
                        text-align: left;
                    }
                    .history-list {
                        margin-top: 10px;
                        
                        img {
                            font-size: 0;
                        }

                        img.click {
                            cursor: pointer;
                        }

                        .history-item {
                            display: inline-block;
                            width: 60px;
                            height: 60px;

                            &:not(:first-child) {
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }
        }
        .btn-row {
            margin-top: 36px;
        }
    }
}
</style>